var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "#222222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 10.7502V7.91683C27.3334 6.3585 26.0584 5.0835 24.5 5.0835H20.25C20.25 2.73183 18.3517 0.833496 16 0.833496C13.6484 0.833496 11.75 2.73183 11.75 5.0835H7.50002C5.94169 5.0835 4.66669 6.3585 4.66669 7.91683V10.7502C2.31502 10.7502 0.416687 12.6485 0.416687 15.0002C0.416687 17.3518 2.31502 19.2502 4.66669 19.2502V24.9168C4.66669 26.4752 5.94169 27.7502 7.50002 27.7502H24.5C26.0584 27.7502 27.3334 26.4752 27.3334 24.9168V19.2502C29.685 19.2502 31.5834 17.3518 31.5834 15.0002C31.5834 12.6485 29.685 10.7502 27.3334 10.7502ZM24.5 24.9168H7.50002V7.91683H24.5V24.9168ZM11.75 16.4168C10.5742 16.4168 9.62502 15.4677 9.62502 14.2918C9.62502 13.116 10.5742 12.1668 11.75 12.1668C12.9259 12.1668 13.875 13.116 13.875 14.2918C13.875 15.4677 12.9259 16.4168 11.75 16.4168ZM22.375 14.2918C22.375 15.4677 21.4259 16.4168 20.25 16.4168C19.0742 16.4168 18.125 15.4677 18.125 14.2918C18.125 13.116 19.0742 12.1668 20.25 12.1668C21.4259 12.1668 22.375 13.116 22.375 14.2918ZM10.3334 19.2502H21.6667V22.0835H10.3334V19.2502Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.5e2d46e7.svg";
export { ForwardRef as ReactComponent };